export default __webpack_public_path__ + "static/media/about.0291f3b7.md";